import React from 'react';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  return (
    <div className="ub-product-card">
      <div className="product-image">
        <img src={product.image} alt={product.name} />
      </div>
      <div className="product-details">
        <h3>{product.name}</h3>
       
        <p className="description">{product.description.substring(0, 60)}...</p>
        
      </div>
    </div>
  );
};

export default ProductCard;